module.exports = __webpack_public_path__ + "media/images/smart_phone/portal/202001/more_btn-c19cde6156bababf91873eac8c9946de.png";